export default "/images/c4bad5fbfb03a66e7fa578cbf0fa382e.avif";